// import { TimelineLite, Power2 } from 'gsap';
const { TimelineLite, Power2 } = window;

// Manage all show-hide accordions

[...document.querySelectorAll('.js-accordion')].forEach((accordion) => {
  const $accordionContent = accordion.querySelector('.js-accordion__content');
  accordion.querySelector('.js-accordion__trigger').addEventListener('click', () => {
    const timeline = new TimelineLite();
    if (!accordion.classList.contains('js-accordion--open')) {
      // Find the expanded height
      timeline.set($accordionContent, {
        visibility: 'hidden',
        position: 'absolute',
        display: 'block',
      });
      const openHeight = $accordionContent.offsetHeight;

      // Reset styles
      timeline
        .set($accordionContent, {
          height: 0,
          position: '',
          visibility: 'visible',
        })
        .call(() => {
          accordion.classList.add('js-accordion--open');
        })
        // Animate to the open state
        .to($accordionContent, 0.2, { height: openHeight, ease: Power2.easeInOut })
        .set($accordionContent, { height: 'auto' });
    } else {
      accordion.classList.remove('js-accordion--open');
      timeline
        .to($accordionContent, 0.2, { height: 0, ease: Power2.easeInOut })
        .set($accordionContent, {
          display: 'none',
          height: 'auto',
        });
    }
  });
});
